import React, { useEffect, useState } from 'react';
import api from '../api';
import { useAdminLanguage } from '../AdminLanguageContext';
import useAdminDialog from '../components/AdminDialog';

export default function Categories() {
  const { copy } = useAdminLanguage();
  const categoriesCopy = copy.categories;
  const [cats, setCats] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', icon: '', items: '', status: 'active', sort_order: '' });
  const [saving, setSaving] = useState(false);
  const { confirmAction, dialog } = useAdminDialog();

  const fetch = () => api.get('/admin/categories').then(res => setCats(res.data));
  useEffect(() => { fetch(); }, []);

  const openCreate = () => {
    setEditing(null);
    setForm({ name: '', description: '', icon: '', items: '', status: 'active', sort_order: '' });
    setShowModal(true);
  };
  const openEdit = (cat) => {
    setEditing(cat);
    setForm({
      name: cat.name,
      description: cat.description || '',
      icon: cat.icon || '',
      items: Array.isArray(cat.items) ? cat.items.join(', ') : '',
      status: cat.status || 'active',
      sort_order: cat.sort_order || '',
    });
    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editing) {
        await api.put(`/admin/categories/${editing.id}`, form);
      } else {
        await api.post('/admin/categories', form);
      }
      await fetch();
      setShowModal(false);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!await confirmAction({
      title: categoriesCopy.deleteConfirm.title,
      message: categoriesCopy.deleteConfirm.message,
      variant: 'danger',
    })) return;
    await api.delete(`/admin/categories/${id}`);
    fetch();
  };

  return (
    <div>
      {dialog}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div className="page-title" style={{ margin: 0 }}>{categoriesCopy.title}</div>
        <button className="btn btn-primary" onClick={openCreate}>+ {categoriesCopy.create}</button>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{categoriesCopy.columns.icon}</th>
                <th>{categoriesCopy.columns.name}</th>
                <th>{categoriesCopy.columns.description}</th>
                <th>{categoriesCopy.columns.subcategories}</th>
                <th>{categoriesCopy.columns.services}</th>
                <th>{categoriesCopy.columns.status}</th>
                <th>{categoriesCopy.columns.sort}</th>
                <th>{categoriesCopy.columns.actions}</th>
              </tr>
            </thead>
            <tbody>
              {cats.map(cat => (
                <tr key={cat.id}>
                  <td style={{ fontSize: 22 }}>{cat.icon}</td>
                  <td style={{ fontWeight: 600 }}>{cat.name}</td>
                  <td style={{ color: '#6b7280' }}>{cat.description}</td>
                  <td>{cat.subcategory_count || 0}</td>
                  <td>{cat.service_count || 0}</td>
                  <td><span className={`badge ${cat.status === 'inactive' ? 'badge-gray' : 'badge-green'}`}>{cat.status === 'inactive' ? categoriesCopy.statusInactive : categoriesCopy.status[cat.status] || cat.status}</span></td>
                  <td>{cat.sort_order}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="btn btn-sm btn-outline" onClick={() => openEdit(cat)}>{categoriesCopy.edit}</button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(cat.id)}>{categoriesCopy.delete}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3>{editing ? categoriesCopy.modal.editTitle : categoriesCopy.modal.createTitle}</h3>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>{categoriesCopy.iconLabel}</label>
                <input value={form.icon} onChange={e => setForm(f => ({ ...f, icon: e.target.value }))} placeholder="" />
              </div>
              <div className="form-group">
                <label>{categoriesCopy.nameLabel}</label>
                <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder={categoriesCopy.namePlaceholder} />
              </div>
              <div className="form-group">
                <label>{categoriesCopy.descriptionLabel}</label>
                <input value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder={categoriesCopy.descriptionPlaceholder} />
              </div>
              <div className="form-group">
                <label>{categoriesCopy.itemsLabel}</label>
                <input value={form.items} onChange={e => setForm(f => ({ ...f, items: e.target.value }))} placeholder={categoriesCopy.itemsPlaceholder} />
              </div>
              <div className="form-group">
                <label>{categoriesCopy.columns.status}</label>
                <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                  <option value="active">{categoriesCopy.status.active}</option>
                  <option value="inactive">{categoriesCopy.statusInactive}</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>{categoriesCopy.cancel}</button>
                <button type="submit" className="btn btn-primary" disabled={saving || !form.name}>
                  {saving ? categoriesCopy.saving : categoriesCopy.save}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
